import createIcon from '../../createIcon';

/**
 * @component @name SpeakerGroup
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguMiAxSDkuOEM4LjgxIDEgOCAxLjgxIDggMi44VjE3LjJDOCAxOC4xOSA4LjgxIDE4Ljk5IDkuOCAxOC45OUwxOC4yIDE5QzE5LjE5IDE5IDIwIDE4LjE5IDIwIDE3LjJWMi44QzIwIDEuODEgMTkuMTkgMSAxOC4yIDFaTTE0IDNDMTUuMSAzIDE2IDMuODkgMTYgNUMxNiA2LjExIDE1LjEgNyAxNCA3QzEyLjkgNyAxMiA2LjExIDEyIDVDMTIgMy44OSAxMi45IDMgMTQgM1pNMTQgMTYuNUMxMS43OSAxNi41IDEwIDE0LjcxIDEwIDEyLjVDMTAgMTAuMjkgMTEuNzkgOC41IDE0IDguNUMxNi4yMSA4LjUgMTggMTAuMjkgMTggMTIuNUMxOCAxNC43MSAxNi4yMSAxNi41IDE0IDE2LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTQgMTVDMTUuMzgwNyAxNSAxNi41IDEzLjg4MDcgMTYuNSAxMi41QzE2LjUgMTEuMTE5MyAxNS4zODA3IDEwIDE0IDEwQzEyLjYxOTMgMTAgMTEuNSAxMS4xMTkzIDExLjUgMTIuNUMxMS41IDEzLjg4MDcgMTIuNjE5MyAxNSAxNCAxNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik02IDVINFYyMUM0IDIyLjEgNC44OSAyMyA2IDIzSDE2VjIxSDZWNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SpeakerGroup = createIcon('SpeakerGroup', [
  [
    'path',
    {
      d: 'M18.2 1H9.8C8.81 1 8 1.81 8 2.8V17.2C8 18.19 8.81 18.99 9.8 18.99L18.2 19C19.19 19 20 18.19 20 17.2V2.8C20 1.81 19.19 1 18.2 1ZM14 3C15.1 3 16 3.89 16 5C16 6.11 15.1 7 14 7C12.9 7 12 6.11 12 5C12 3.89 12.9 3 14 3ZM14 16.5C11.79 16.5 10 14.71 10 12.5C10 10.29 11.79 8.5 14 8.5C16.21 8.5 18 10.29 18 12.5C18 14.71 16.21 16.5 14 16.5Z',
      key: '1oezhr',
    },
  ],
  [
    'path',
    {
      d: 'M14 15C15.3807 15 16.5 13.8807 16.5 12.5C16.5 11.1193 15.3807 10 14 10C12.6193 10 11.5 11.1193 11.5 12.5C11.5 13.8807 12.6193 15 14 15Z',
      key: '3uywg',
    },
  ],
  ['path', { d: 'M6 5H4V21C4 22.1 4.89 23 6 23H16V21H6V5Z', key: 'lyyc0r' }],
]);

export default SpeakerGroup;
